import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { type SetStateAction, useCallback } from "react";
import type { IMovieActivity } from "src/lib/filmwebid/IMovieActivity";
import { useMovieIdentifierQueryParam, type IFilmwebIdMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";
import { buildUserApiQueryKey, useUserApiQuery } from "src/lib/filmwebid/useUserApiQuery";
export default function useMovieActivity(movieIdentifier) {
  const $ = _c(11);
  const queryClient = useQueryClient();
  const enabled = !!movieIdentifier;
  const movieIdentifierParam = useMovieIdentifierQueryParam(movieIdentifier);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: "GET",
      allowAnon: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== enabled) {
    t1 = {
      enabled,
      refetchOnWindowFocus: false,
      staleTime: 0
    };
    $[1] = enabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    isLoading,
    refetch
  } = useUserApiQuery("/api/Movie/MovieActivity", movieIdentifierParam, t0, t1);
  let t2;
  if ($[3] !== movieIdentifierParam || $[4] !== queryClient) {
    t2 = activity => {
      const queryKey = buildUserApiQueryKey("/api/Movie/MovieActivity", movieIdentifierParam);
      let newValue;
      if (typeof activity === "function") {
        const old = queryClient.getQueryData(queryKey);
        newValue = activity(old);
      } else {
        newValue = activity;
      }
      queryClient.setQueryData(queryKey, newValue);
    };
    $[3] = movieIdentifierParam;
    $[4] = queryClient;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const optimisticUpdater = t2;
  const movieActivity = data ?? null;
  let t3;
  if ($[6] !== isLoading || $[7] !== movieActivity || $[8] !== optimisticUpdater || $[9] !== refetch) {
    t3 = [movieActivity, refetch, isLoading, optimisticUpdater];
    $[6] = isLoading;
    $[7] = movieActivity;
    $[8] = optimisticUpdater;
    $[9] = refetch;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}